var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{class:("chart-" + (this.id) + " chart-js"),attrs:{"width":(_vm.width + "px"),"height":(_vm.height + "px")}})])}
var staticRenderFns = []

export { render, staticRenderFns }